import AdminUsersService from "@/client/services/api/admin/users/AdminUsersService";
import { useQuery } from "@tanstack/react-query";

export const useGetAdminUsersContentStats = (userId: string | undefined) =>
  useQuery({
    enabled: !!userId,
    queryKey: ["user-content-stats", userId],
    queryFn: () => AdminUsersService.getUserContentStats(userId),
  });
